<template>
  <div
    :style="{
      backgroundImage: 'url(' + bg + ')',
      backgroundPosition: 'center',
    }"
  >
    <v-container grid-list-lg>
      <!-- <v-card>
        <v-layout
            class="mb-3"
            align-center
            justify-center
            wrap  
          >
          <v-flex md4 order-sm2 class="mb-8" :style="{position:'relative',left:'5%'}">
            <strong>
              <span class="primary--text"><b>{{linkedWebinars.length}}</b></span>
              <span> Links added since</span>
            </strong>
            <span>as of {{linkedWebinars.length > 0 ? convertDate(linkedWebinars[0].created_at) : ""}}
            </span>
          </v-flex>
          <v-flex md4 order-sm2 class="mb-8" id="searchField" :style="{position:'relative',left:'5%'}">
            <v-text-field
              :style="{width:'90%'}"
              @input="handleChange"
              solo
              label="Search Webinar Link"
              prepend-icon="search"
              v-model="search"
            ></v-text-field>
          </v-flex>
          <v-flex md4 order-sm2 class="mb-8">
            <center>
              <v-select
                @change="handleFilter"
                :style="{width:'50%'}"
                :items="filterTypes"
                label="Category"
                v-model="categoryText"
              ></v-select>
            </center>
          </v-flex>
          
        </v-layout>
      </v-card> -->
      <v-card class="pa-4 mb-2">
        <v-layout wrap justify-center>
          <v-flex md10>
            <h1>Use the following link to download the Thyroid Cheat Cards.</h1>
            <br />
            <v-card class="pa-4 mb-2">
              <v-list two-line subheader>
                <v-list-tile
                  avatar
                  v-for="(webinar, i) in searchLinked"
                  :key="i"
                >
                  <v-list-tile-content>
                    <v-list-tile-title
                      ><a v-bind:href="webinar.url" target="_blank">
                        {{ webinar.title }}
                      </a></v-list-tile-title
                    >
                    <v-list-tile-sub-title>
                      <span class="accent--text">{{ webinar.category }}</span>
                      <span> - </span>
                      <span>{{ convertDate(webinar.created_at) }}</span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
      <v-layout>
        <v-dialog v-model="dialog" max-width="500">
          <v-card>
            <v-card-title class="headline">{{
              selectedWebinar.title
            }}</v-card-title>
            <div>
              <Media
                :style="{ width: '500px' }"
                :kind="'video'"
                :controls="true"
                :src="[url + selectedWebinar.video]"
              >
              </Media>
            </div>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" text @click="dialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Media from "@dongido/vue-viaudio";
import axios from "axios";
import config from "../../../configApi";
import moment from "moment";

const apiUrl = config.apiUrl;
const filesUrl = config.filesUrl;

export default {
  data() {
    return {
      bg: require("@/assets/bg/water_6.png"),
      search: "",
      rowsPerPageItems: [3, 6, 12, 18],
      pagination: {
        rowsPerPage: 5,
      },
      dialog: false,
      selectedWebinar: {},
      recordedWebinars: [],
      linkedWebinars: [
        {
          title: "Goiter and Nodule",
          url: "https://bit.ly/GoiterandNodule",
          image: "",
          category: "",
          created_at: "2024-07-05",
        },
        {
          title: "Hyperthyroidism",
          url: "https://bit.ly/elitehyperthyroidism",
          image: "",
          category: "",
          created_at: "2024-07-05",
        },
        {
          title: "Hypothyroidism",
          url: "https://bit.ly/elitehypothyroidism",
          image: "",
          category: "",
          created_at: "2024-07-05",
        },
        {
          title: "Subclinical Hypothyroidism",
          url: "https://bit.ly/elitesubclinicalhypothyroidism",
          image: "",
          category: "",
          created_at: "2024-07-05",
        },
        {
          title: "Thyroid Disorders in Pregnancy",
          url: "https://bit.ly/thyroidinpregnancy",
          image: "",
          category: "",
          created_at: "2024-07-05",
        },
      ],
      searchLinked: [
        {
          title: "Goiter and Module",
          url: "/static/pptx/GoiterandNodule.pptx",
          image: "",
          category: "",
          created_at: "2024-07-05",
        },
        {
          title: "Hyperthyroidism",
          url: "/static/pptx/Hyperthyroidism.pptx",
          image: "",
          category: "",
          created_at: "2024-07-05",
        },
        {
          title: "Hypothyroidism",
          url: "/static/pptx/Hypothyroidism.pptx",
          image: "",
          category: "",
          created_at: "2024-07-05",
        },
        {
          title: "Subclinical Hypothyroidism",
          url: "/static/pptx/SubclinicalHypothyroidism.pptx",
          image: "",
          category: "",
          created_at: "2024-07-05",
        },
        {
          title: "Thyroid Disorders in Pregnancy",
          url: "/static/pptx/ThyroidDisordersinPregnancy.pptx",
          image: "",
          category: "",
          created_at: "2024-07-05",
        },
      ],
      searchRecorded: [],
      filterTypes: ["All"],
      url: apiUrl.replace("api", ""),
      filesUrl,
      categoryText: "",
    };
  },
  components: {
    Media,
  },
  mounted() {
    this.fetchData();
  },
  updated() {
    this.updateLog();
  },
  methods: {
    downloadPDF(url, title) {
      // Reference to the PDF file in the public folder
      const pdfUrl = url; // BASE_URL automatically points to /public folder in Vue

      // Create a temporary anchor element
      const downloadLink = document.createElement("a");
      downloadLink.href = pdfUrl;
      downloadLink.download = `${title}.pdf`; // The name of the downloaded file

      // Append the link to the DOM, trigger the click and remove it from the DOM
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    updateLog() {},
    // handleFilter(selected) {
    //   if (selected === "All") {
    //     selected = "";
    //   }
    //   let data = this.linkedWebinars.filter((val) =>
    //     val.category
    //       ? val.category.toLowerCase().includes(selected.toLowerCase())
    //       : []
    //   );
    //   let recordedData = this.recordedWebinars.filter((val) =>
    //     val.category
    //       ? val.category.toLowerCase().includes(selected.toLowerCase())
    //       : []
    //   );
    //   this.searchRecorded = recordedData;
    //   this.searchLinked = data;
    //   this.search = "";
    // },
    // handleChange() {
    //   let { search, linkedWebinars } = this;
    //   let data = linkedWebinars.filter((val) =>
    //     val.title ? val.title.toLowerCase().includes(search.toLowerCase()) : []
    //   );
    //   this.searchLinked = data;
    //   this.categoryText = "";
    // },
    fetchData() {
      this.getWebinar();
    },
    convertDate(date) {
      return moment(date).format("LL");
    },
    getWebinar() {
      axios
        .get(`${apiUrl}/webinar`)
        .then((res) => {
          this.recordedWebinars = res
            ? res.data.filter((val) => val.is_recorded === 1)
            : [];
          // this.linkedWebinars = res
          //   ? res.data.filter((val) => val.is_recorded === 0)
          //   : this.linkedWebinars;
          // this.searchLinked = this.linkedWebinars;
          this.searchRecorded = this.recordedWebinars;

          this.searchLinked.map((row) => {
            if (!this.filterTypes.includes(row.category)) {
              this.filterTypes.push(row.category);
            }
          });
          this.searchRecorded.map((row) => {
            if (!this.filterTypes.includes(row.category)) {
              this.filterTypes.push(row.category);
            }
          });
        })
        .catch((e) => {
          console.log("error", e);
        });
    },
    handleClick(webinar) {
      this.dialog = true;
      this.selectedWebinar = webinar;
    },
  },
};
</script>
<style scoped>
.position {
  font: "initial";
}
a {
  text-decoration: none;
  color: black;
  font-weight: bold;
}
#searchField {
  position: relative;
  top: 1.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/webinar_links.vue